var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-card',{attrs:{"no-body":""}},[_vm._v("\n    grafana test\n    "),_c('iframe',{attrs:{"src":"https://grafana-pweb.chorum.fr:3000/d-solo/o6g_y7a4z/atlas-prod-dashboard?orgId=1&refresh=10s&from=1679993030632&to=1679996630632&panelId=15","width":"450","height":"200","frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }